var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24026 12.9578L13.8215 7.37656C15.1928 6.00521 15.3951 3.74912 14.0974 2.30793C13.7723 1.9459 13.3769 1.65389 12.9352 1.44972C12.4936 1.24556 12.0149 1.13351 11.5286 1.12044C11.0422 1.10736 10.5582 1.19351 10.1062 1.37365C9.65425 1.55378 9.24371 1.82412 8.89965 2.16816L7.85063 3.21717L6.94492 2.31146C5.57357 0.9401 3.31748 0.737778 1.87629 2.03554C1.51426 2.36061 1.22225 2.75604 1.01808 3.19769C0.813915 3.63934 0.701874 4.11796 0.688794 4.60435C0.675715 5.09073 0.761871 5.57468 0.942006 6.02667C1.12214 6.47866 1.39248 6.8892 1.73652 7.23326L7.46101 12.9578C7.56435 13.0611 7.7045 13.1191 7.85063 13.1191C7.99677 13.1191 8.13692 13.0611 8.24026 12.9578V12.9578Z",
    stroke: "#123051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHeart);
export default __webpack_public_path__ + "static/media/blueHeart.51d9e4d8d9b9dec29c5247c2516e0419.svg";
export { ForwardRef as ReactComponent };